'use client';

import { c as _c } from "react/compiler-runtime";
import { useDraw, useGetDrawResult } from '@svenskaspelab/poolbetting/core/frameworks/nextjs/draw';
import type { DrawNumber } from '@svenskaspelab/poolbetting/schema/draw';
import type { Definition } from '@svenskaspelab/poolbetting/schema/frameworks';
import type { EventNumber } from '@svenskaspelab/poolbetting/schema/sport';
import { Separator } from '@svenskaspelab/ui/react/separator';
import type { ReactNode } from 'react';
import { SportinfoModalHeaderResultPresentational } from './SportinfoModalHeaderResultPresentational';
type SportinfoModalHeaderResultContainerClientProps = {
  product: Definition['drawProducts'][number];
  drawNumber: DrawNumber;
  eventNumber: EventNumber;
};

/**
 * Client container fetching the draw and its result via hooks for the sportinfo modal result header,
 * keeping match status, participants and result live-updated.
 *
 * @param root0 component props
 * @param root0.product product for current draw
 * @param root0.drawNumber draw number for current draw
 * @param root0.eventNumber event number to show the result for
 * @returns Header component for the sportinfo modal
 */
export function SportinfoModalHeaderResultContainerClient(t0) {
  const $ = _c(33);
  const {
    product,
    drawNumber,
    eventNumber
  } = t0;
  let t1;
  if ($[0] !== drawNumber || $[1] !== product) {
    t1 = {
      product,
      drawNumber
    };
    $[0] = drawNumber;
    $[1] = product;
    $[2] = t1;
  } else {
    t1 = $[2];
  }
  const {
    data,
    isError
  } = useDraw(t1);
  let t2;
  if ($[3] !== drawNumber || $[4] !== product) {
    t2 = {
      product,
      drawNumber
    };
    $[3] = drawNumber;
    $[4] = product;
    $[5] = t2;
  } else {
    t2 = $[5];
  }
  const {
    data: drawResultData
  } = useGetDrawResult(t2);
  if (isError) {
    return;
  }
  const {
    bettingEvent,
    draw,
    participants
  } = data;
  let t3;
  if ($[6] !== draw.events || $[7] !== eventNumber) {
    let t4;
    if ($[9] !== eventNumber) {
      t4 = drawEvent => drawEvent.eventNumber === eventNumber;
      $[9] = eventNumber;
      $[10] = t4;
    } else {
      t4 = $[10];
    }
    t3 = draw.events.find(t4);
    $[6] = draw.events;
    $[7] = eventNumber;
    $[8] = t3;
  } else {
    t3 = $[8];
  }
  const event = t3;
  if (!event || event.status !== "COMPLETE") {
    return;
  }
  const eventBettingEvent = bettingEvent[event.bettingEventId];
  if (!eventBettingEvent) {
    return;
  }
  let t4;
  if ($[11] !== eventBettingEvent.participants || $[12] !== participants) {
    let t5;
    if ($[14] !== participants) {
      t5 = participantId => participants[participantId];
      $[14] = participants;
      $[15] = t5;
    } else {
      t5 = $[15];
    }
    t4 = eventBettingEvent.participants.map(t5);
    $[11] = eventBettingEvent.participants;
    $[12] = participants;
    $[13] = t4;
  } else {
    t4 = $[13];
  }
  const eventParticipants = t4;
  let t5;
  if ($[16] !== drawResultData.data || $[17] !== drawResultData.type || $[18] !== eventNumber) {
    t5 = drawResultData.type === "NONE" ? undefined : drawResultData.data.drawResults.find(eventResult => eventResult.eventNumber === eventNumber);
    $[16] = drawResultData.data;
    $[17] = drawResultData.type;
    $[18] = eventNumber;
    $[19] = t5;
  } else {
    t5 = $[19];
  }
  const drawEventResult = t5;
  const t6 = drawEventResult?.matchResult.client;
  const t7 = drawEventResult?.result;
  const t8 = drawEventResult?.isCancelled;
  let t9;
  if ($[20] !== draw.sportType || $[21] !== event.eventDescription || $[22] !== eventBettingEvent.startDate || $[23] !== eventBettingEvent.status || $[24] !== eventBettingEvent.statusTime || $[25] !== eventParticipants || $[26] !== t6 || $[27] !== t7 || $[28] !== t8) {
    t9 = <SportinfoModalHeaderResultPresentational participants={eventParticipants} eventDescription={event.eventDescription} eventStatus={eventBettingEvent.status} sportType={draw.sportType} matchStart={eventBettingEvent.startDate} statusTime={eventBettingEvent.statusTime} matchResultState={t6} result={t7} isCancelled={t8} />;
    $[20] = draw.sportType;
    $[21] = event.eventDescription;
    $[22] = eventBettingEvent.startDate;
    $[23] = eventBettingEvent.status;
    $[24] = eventBettingEvent.statusTime;
    $[25] = eventParticipants;
    $[26] = t6;
    $[27] = t7;
    $[28] = t8;
    $[29] = t9;
  } else {
    t9 = $[29];
  }
  let t10;
  if ($[30] === Symbol.for("react.memo_cache_sentinel")) {
    t10 = <Separator className="my-1" />;
    $[30] = t10;
  } else {
    t10 = $[30];
  }
  let t11;
  if ($[31] !== t9) {
    t11 = <>{t9}{t10}</>;
    $[31] = t9;
    $[32] = t11;
  } else {
    t11 = $[32];
  }
  return t11;
}